const isMobile = () => {
	return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || 'ontouchstart' in window || (navigator.maxTouchPoints && navigator.maxTouchPoints > 0);
};

export default isMobile;
